import {
  AvatarV2,
  Button,
  Container,
  Icon,
  Notifications,
  Text,
} from "@jds/core";
import { useCallback, useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";
import cover from "../../../../assets/png/cover.png";
import {
  imgValidationCheck,
  optionalFaceDetectionIdList,
  validateFileSignature,
} from "../../../../util/helper";
import ImageCropper from "../../ImageCropper/ImageCropper";
import { ImageCrop } from "../../ImageCrop/ImageCrop";
import useApiHttp from "../../../../hooks/use-http";
import PageLoader from "../../Loader/PageLoader";
import { useSelector } from "react-redux";
const AvatarUploadCamera = (props) => {
  const profileDetailsRedux = useSelector(
    (state) => state.profileDetails.profileDetails
  );
  const isOptionalId = optionalFaceDetectionIdList.findIndex(val => val === profileDetailsRedux.email) > -1
  // console.log('Email check ====', optionalFaceDetectionIdList.findIndex(val => val === 'deepan.thirupaathy@ril.com'))
  const { sendRequest: getFaceCount, isLoading: isGetFaceCounting } =
    useApiHttp();
  const [fileBlob, setFileBlod] = useState();
  const [fileChange, setFileChange] = useState(false);
  const [userSelectedFile, setUserSelectedFile] = useState();
  const [cameraSelect, setCameraSelect] = useState(false);
  const [saveOrCropView, setSaveOrCropView] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const {
    image,
    fileValue = () => { },
    accept,
    setProfileHeader = () => { },
  } = props;

  const fileRef = useRef(null);
  const fileInRef = useRef(null);
  const webcamRef = useRef(null);

  function dataURItoFile(dataURI, filename) {
    // convert base64/URLEncoded data component to raw binary data
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0) {
      byteString = atob(dataURI.split(",")[1]);
    } else {
      byteString = unescape(dataURI.split(",")[1]);
    }
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    // create a File object from the typed array
    var temp = new File([ia], filename, { type: mimeString });
    return temp;
  }

  const capturePhoto = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    let currentDate = new Date();
    let dateTimeString =
      currentDate.getFullYear() +
      String(currentDate.getMonth() + 1).padStart(2, "0") +
      String(currentDate.getDate()).padStart(2, "0") +
      "T" +
      String(currentDate.getHours()).padStart(2, "0") +
      String(currentDate.getMinutes()).padStart(2, "0") +
      String(currentDate.getSeconds()).padStart(2, "0");

    dateTimeString = dateTimeString + ".jpg";
    var imgFile = dataURItoFile(imageSrc, dateTimeString);
    return imgFile;
  }, [webcamRef]);

  const profileCapture = () => {
    var imgFile = capturePhoto();
    setFileBlod(URL.createObjectURL(imgFile));
    setUserSelectedFile(imgFile);
    setFileChange(true);
    setCameraSelect(false);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      setImageSrc(reader.result);
      setCameraSelect(false);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };
  const handleImageCrop = () => {
    const reader = new FileReader();

    reader.onloadend = () => {
      setImageSrc(reader.result);
      setCameraSelect(false);
    };

    if (userSelectedFile) {
      reader.readAsDataURL(userSelectedFile);
    }
  };

  const backToOption = () => {
    console.log("hello back", saveOrCropView);

    setImageSrc(null);
    setCameraSelect(false);
  };

  useEffect(() => {
    if (cameraSelect) {
      setProfileHeader("Align your face and click capture");
    } else {
      setProfileHeader("Upload profile picture");
    }
  }, [cameraSelect]);
  return (
    <>
      <input
        type="file"
        ref={fileInRef}
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files[0];
          if (imgValidationCheck(e)) {
            validateFileSignature(file, {
              jpeg: ["ffd8ffe0", "ffd8ffe1", "ffd8ffe2", "ffd8ffdb"], // JPEG signatures can vary
              png: ["89504e47"],
            })
              .then((isValid) => {
                if (isValid) {
                  handleImageChange(e);
                } else {
                  Notifications.toast.error({
                    id: "avatar-upload-camera-img",
                    title:
                      "Please upload a valid image file (JPG, JPEG and PNG).",
                  });
                }
              })
              .catch((error) => {
                Notifications.toast.error({
                  id: "avatar-upload-camera-img",
                  title:
                    "Please upload a valid image file (JPG, JPEG and PNG).",
                });
              });
          } else {
            Notifications.toast.error({
              id: "avatar-upload-camera-img",
              title: "Please upload a valid image file (JPG, JPEG and PNG).",
            });
          }
        }}
        accept={accept}
        id="avatarUpload"
      />
      <input
        ref={fileRef}
        type="file"
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files[0];
          if (imgValidationCheck(e)) {
            validateFileSignature(file, {
              jpeg: ["ffd8ffe0", "ffd8ffe1", "ffd8ffe2", "ffd8ffdb"], // JPEG signatures can vary
              png: ["89504e47"],
            })
              .then((isValid) => {
                if (isValid) {
                  setFileBlod(URL.createObjectURL(file));
                  setUserSelectedFile(file);
                  setSaveOrCropView(true);
                  // setFileChange(true);
                } else {
                  Notifications.toast.error({
                    id: "avatar-upload-camera-img",
                    title:
                      "Please upload a valid image file (JPG, JPEG and PNG).",
                  });
                }
              })
              .catch((error) => {
                Notifications.toast.error({
                  id: "avatar-upload-camera-img",
                  title:
                    "Please upload a valid image file (JPG, JPEG and PNG).",
                });
              });
          } else {
            Notifications.toast.error({
              id: "avatar-upload-camera-img",
              title: "Please upload a valid image file (JPG, JPEG and PNG).",
            });
          }
        }}
        accept={accept}
        id="avatarUpload"
      />

      {!cameraSelect && !imageSrc && (
        <Container
          fullWidth
          direction="column"
          // horizontalAlign="center"
          style={{ gap: "32px", position: "relative" }}
        >
          <Container fullWidth direction="row" horizontalAlign="center">
            <AvatarV2
              size="xtra-xtra-large"
              avatarKind={image || fileBlob ? "image" : "icon"}
              badgeBorder={false}
              image={fileBlob ? fileBlob : image}
            />
          </Container>
          {saveOrCropView && (
            <Container fullWidth direction="column">
              <div
                onClick={() => {
                  setSaveOrCropView(false);
                  setFileBlod(null);
                  setUserSelectedFile(null);
                  setFileChange(false);
                }}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  marginBottom: "16px",
                  position: "absolute",
                  top: 0,
                  left: 0,
                }}
              >
                <Icon ic={"IcChevronLeft"} color="primary_60" />
                <Text text="Back" appearance="body_s_bold" color="primary_60" />
              </div>
              <Container fullWidth direction="row" gap={"10px"}>
                <Button
                  type="submit"
                  fullWidth
                  kind="secondary"
                  size="large"
                  label="Button"
                  onClick={() => {
                    // setFileChange(true);
                    // setSaveOrCropView(false);
                    const formData = new FormData();
                    formData.append("uploadFile", userSelectedFile);
                    // if (!isOptionalId) {
                    //   getFaceCount(
                    //     {
                    //       base: "MEDIA",
                    //       url: `face/get-face-count`,
                    //       method: "POST",
                    //       body: formData,
                    //       formData: true,
                    //     },
                    //     null,
                    //     (data) => {
                    //       fileValue(userSelectedFile);
                    //       props.closeModal();
                    //     },
                    //     (err, data) => {
                    //       Notifications.toast.error({
                    //         id: "get-face-count-error",
                    //         title: data?.message,
                    //       });
                    //     }
                    //   );
                    // } else {
                    //   fileValue(userSelectedFile);
                    //   props.closeModal();
                    // }
                    fileValue(userSelectedFile);
                    props.closeModal();
                  }}
                >
                  Save
                </Button>

                <Button
                  fullWidth
                  kind="primary"
                  size="large"
                  label="Button"
                  onClick={() => {
                    handleImageCrop();
                  }}
                >
                  Crop
                </Button>
              </Container>
            </Container>
          )}
          {fileChange && (
            <Container fullWidth direction="row" gap={"10px"}>
              {/* <Button
                type="submit"
                fullWidth
                kind="secondary"
                size="large"
                label="Button"
                onClick={() => {
                  props.closeModal();
                }}
              >
                Cancel
              </Button> */}
              <Button
                type="submit"
                fullWidth
                kind="secondary"
                size="large"
                label="Button"
                onClick={() => {
                  setFileBlod(null);
                  setUserSelectedFile(null);
                  setFileChange(false);
                }}
              >
                Cancel
              </Button>
              <Button
                fullWidth
                kind="primary"
                size="large"
                label="Button"
                onClick={() => {
                  const formData = new FormData();
                  formData.append("uploadFile", userSelectedFile);
                  // if (!isOptionalId) {
                  //   getFaceCount(
                  //     {
                  //       base: "MEDIA",
                  //       url: `face/get-face-count`,
                  //       method: "POST",
                  //       body: formData,
                  //       formData: true,
                  //     },
                  //     null,
                  //     (data) => {
                  //       fileValue(userSelectedFile);
                  //       props.closeModal();
                  //     },
                  //     (err, data) => {
                  //       Notifications.toast.error({
                  //         id: "get-face-count-error",
                  //         title: data?.message,
                  //       });
                  //     }
                  //   );
                  // } else {
                  //   fileValue(userSelectedFile);
                  //   props.closeModal();
                  // }
                  fileValue(userSelectedFile);
                  props.closeModal();
                }}
              >
                Proceed
              </Button>
            </Container>
          )}
          {!fileChange && !saveOrCropView && (
            <Container fullWidth direction="row" gap={"10px"}>
              <Button
                type="submit"
                fullWidth
                kind="secondary"
                size="large"
                label="Button"
                onClick={() => {
                  if (fileRef.current) {
                    fileRef.current.value = null; // Reset file input
                  }
                  if (fileRef.current) {
                    fileRef.current.click(); // Open file dialog
                  }
                }}
              >
                Browse
              </Button>
              {/* <Button
                type="submit"
                fullWidth
                kind="secondary"
                size="large"
                label="Button"
                onClick={() => {
                  if (fileInRef.current) {
                    fileInRef.current.value = null; // Reset file input
                  }
                  if (fileInRef.current) {
                    fileInRef.current.click(); // Open file dialog
                  }
                }}
              >
                Browse
              </Button> */}
              <Button
                fullWidth
                kind="primary"
                size="large"
                label="Button"
                onClick={() => {
                  setCameraSelect(true);
                  setImageSrc(null);
                }}
              >
                Camera
              </Button>
            </Container>
          )}
        </Container>
      )}

      {cameraSelect && (
        <Container
          fullWidth
          direction="column"
          horizontalAlign="center"
          style={{ gap: "32px" }}
        >
          <div style={{ position: "relative" }}>
            <div
              style={{
                border: "1px solid black",
                width: "188px",
                height: "188px",
                borderRadius: "50%",
                overflow: "hidden",
              }}
            >
              {/* <img
                src={cover}
                style={{ zIndex: "-15", position: "absolute", width: "210px" }}
              /> */}
              <Webcam
                ref={webcamRef}
                audio={false}
                screenshotFormat="image/jpeg"
                videoConstraints={{
                  width: 188,
                  height: 188,
                  facingMode: "user",
                }}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  "::-webkit-media-controls": { display: "none" },
                  "::-webkit-media-controls-enclosure": { display: "none" },
                  "::-webkit-media-controls-panel": { display: "none" },
                }}
                mirrored={true}
                onClick={(e) => {
                  e.preventDefault();
                }}
              />
            </div>
          </div>

          <Button
            fullWidth
            kind="primary"
            size="large"
            label="Button"
            onClick={() => {
              profileCapture();
            }}
          >
            Capture
          </Button>
        </Container>
      )}

      {imageSrc && (
        <>
          <div
            onClick={() => {
              backToOption();
            }}
            style={{
              cursor: "pointer",
              display: "flex",
              marginBottom: "16px",
            }}
          >
            <Icon ic={"IcChevronLeft"} color="primary_60" />
            <Text text="Back" appearance="body_s_bold" color="primary_60" />
          </div>
          <ImageCrop
            src={imageSrc}
            setFileBlod={(blob, file) => {
              setUserSelectedFile(file);
              setFileChange(true);
              setFileBlod(blob);
              setSaveOrCropView(false);
            }}
            backFun={backToOption}
          />
        </>
      )}

      {isGetFaceCounting && <PageLoader open={isGetFaceCounting} />}
    </>
  );
};

export default AvatarUploadCamera;
